export class SlicesImage {

  constructor(props = {}) {
    this.previewUrl = props.url;
    this.sizes = props.sizes;
  }

  get DEFAULT_IMAGE() {
    return {url: this.DEFAULT_URI, sizes: []};
  }

  get DEFAULT_URI() {
    return 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  }

  get url() {
    const sizes = this.sizes;
    if(!sizes[0]) return undefined;
    return sizes[0].url;
  }

  get previewUrl() {
    return this['#previewUrl'] || this.DEFAULT_URI;
  }

  set previewUrl(previewUrl = '') {
    if(previewUrl.substr(0,11) !== 'data:image/') return;
    this['#previewUrl'] = previewUrl;
  }

  get sizes() {
    return this['#sizes'] || [];
  }

  set sizes(sizes = []) {
    this['#sizes'] = sizes;
  }

  get hidden() {
    return this.sizes.length === 0;
  }

}